import React, { useState } from "react";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { useAlert } from "../../../context/AlertContext";
import { jwtDecode } from "jwt-decode";

export const SchedulePopoverTest = ({
  appointments,
  setUpdateActiveReschedule,
  setModalState,
}) => {
  const { showAlert, closeAlert } = useAlert();
  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;

  const [activeClientId, setClientActiveId] = useState(decoded?.id || null);
  const [isPopupVisible, setIsPopupVisible] = useState(true);

  const handleButtonClick = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const formatDateAndTime = (dateString) => {
    const date = new Date(dateString);

    const formattedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;

    const formattedTime = `${date.getHours()}:${
      date.getMinutes() < 10 ? "0" : ""
    }${date.getMinutes()}`;

    return { formattedDate, formattedTime };
  };

  const addBooking = async () => {
    if (!realAppointments || !realAppointments.length) {
      setModalState();
      return;
    }
    try {
      const client_id = activeClientId;
      const timeSlots = Object.keys(realAppointments).map((appointment) => ({
        client_id: client_id,
        status: realAppointments[appointment].bookings_client.length
          ? "canceled"
          : "book",
        start: new Date(realAppointments[appointment].start),

        timeSlot_id: realAppointments[appointment].id,
      }));

      const data = {
        timeSlots: timeSlots,
      };

      // console.log(data, "data");
      // return;

      const response = await ApiMethods.post(
        "auth/add_booking_cancelation",
        data
      );
      setModalState();
      setUpdateActiveReschedule();
      showAlert("Uspesna izmena", "success");
    } catch (err) {}
  };

  const realAppointments =
    appointments &&
    Object.values(appointments)
      .filter((appointment) => appointment.checked)
      .filter((value, index, self) => {
        return index === self.findIndex((t) => t.id === value.id);
      });

  return (
    <div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 999,
        }}
        onClick={() => setModalState()}
      ></div>

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "300px",
          height: "230px",
          backgroundColor: "white",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          padding: "20px",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <span className="header-change-booking">Izmeni termin</span>

        {realAppointments && realAppointments.length > 0 ? (
          <div
            style={{
              display: "flex",
              marginBottom: "20px",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {realAppointments.map((appointment, index) => {
              const { formattedDate, formattedTime: startTime } =
                formatDateAndTime(appointment.start);
              const { formattedTime: endTime } = formatDateAndTime(
                appointment.end
              );

              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "20px",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "black",
                      marginRight: "10px",
                    }}
                  ></span>

                  <span
                    style={{
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "700",
                    }}
                  >
                    {formattedDate} - {startTime}-{endTime}{" "}
                    {!appointment.bookings_client.length ? (
                      <span style={{ fontSize: "12px", color: "#34B63A" }}>
                        {" "}
                        (zakazan)
                      </span>
                    ) : (
                      <span style={{ fontSize: "12px", color: "#E4322D" }}>
                        {" "}
                        (otkazan)
                      </span>
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        ) : (
          <span style={{ fontSize: "12px", color: "#E4322D" }}>
            Nema dostupnih termina
          </span>
        )}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            className="close-change-booking"
            onClick={() => setModalState()}
          >
            Otkazi
          </button>
          <button className="reschedule-change-booking" onClick={addBooking}>
            Izmeni
          </button>
        </div>
      </div>
    </div>
  );
};
